// @flow
export const LayoutHintConfiguration = {
  MANDATORY: {
    hint: "mandatory",
    description: {
      NL: "Geeft aan of een attribuut verplicht is. Dient samen met de dependency hint gebruikt te worden.",
      EN: "Indicates a mandatory attribute.\nShould be used together with the dependency hint.",
    },
    link: "",
    component: ["attribute"],
  },
  DEPENDENT_ATTRIBUTE_CONTROL: {
    hint: "dependent-control:${unique-control-id}",
    description: {
      NL: "Geeft aan dat dit het attribuut is waar attributen van afhankelijk zijn. Het unique-control-id is een uniek id dat kan worden gebruikt in the hint voor de show|hide actie op het afhankelijke attribuut.",
      EN: "Marks the choice attribute where other attributes depend on. The unique control id is a unique id that can be used in the hint for the show|hide action on the dependent attribute.",
    },
    link: "",
    component: ["attribute/boolean", "attribute/choice"],
  },
  DEPENDENT_ATTRIBUTE_ACTION: {
    hint: "dependent-attribute:(show|hide) when dependent-control:${unique-control-id} (equals|includes|notEquals|notIncludes) [${codemaps}]",
    description: {
      NL: "Toon of verberg een attribute dat afhankelijk is van de geselecteerde opties van een keuze attribute",
      EN: "To show or hide an attribute dependent on options of the choice control codemap that are selected or not selected.",
    },
    link: "",
    component: ["attribute"],
  },
  SHOW_ONE_RESULT_AS_DETAIL: {
    hint: "show-one-result-as-detail",
    description: {
      NL: "Een lijst met maar één item mag direct als detail getoond worden.",
      EN: "A list with only one detail must be shown as a detail.",
    },
    link: "",
    component: ["list"],
  },
  HIDE_WHEN_EMPTY: {
    hint: "hide-when-empty",
    description: {
      NL: "Een lijst zonder lijst-items en lijst-taken dient niet getoond worden.",
      EN: "A list without list-items and list-tasks should not be shown.",
    },
    link: "",
    component: ["list"],
  },
  INITIAL_FILTER: {
    hint: "initial-filter:${filter-name}=${initial-value}",
    description: {
      NL: "Laad de lijst met een standaardwaarde voor een filter, er is geen controle op het bestaan van het filter. Als het filter niet is geconfigureerd, treedt er een fout op. Houd er rekening mee dat filters hoofdlettergevoelig zijn.",
      EN: "Load the list with a default value for a filter, there is no check for the existence of the filter. If the filter is not configured, an error occurs. Keep in mind that filters are case sensitive.",
    },
    link: "",
    component: ["list"],
  },
  CONFIRM_PASSWORD: {
    hint: "confirm-password",
    description: {
      NL: "Wachtwoord attribuut moet bevestigd worden dmv een tweede wachtwoord attribuut.",
      EN: "Password attribute must be confirmed using a second password attribute.",
    },
    link: "",
    component: ["attribute/password"],
  },
  TITLE: {
    hint: "title",
    description: {
      NL: "Markeert een attribuut als een titel attribuut",
      EN: "Marks an attribute as a title attribute",
    },
    link: "",
    component: [
      "caseview_table",
      "codemap",
      "list/appointment_table",
      "list/assignment_table",
      "list/caseproperties_table",
      "list/document_table",
      "list/timelimit_table",
      "list/eventhistory_table",
      "list/note_table",
      "list/record_table",
      "list/case_table",
      "list/casesearch_table",
      "list/datastore_table",
      "list/datastoreview_table",
      "list/instrumentresult_table",
      "list/event_table",
      "list/user_table",
      "list/organization_table",
    ],
  },
  INITIAL_TOTAL_FILESIZE: {
    hint: "initial-total-file-size",
    description: {
      NL: "Wordt gebruikt in samenwerking met een upload attribuut, deze hint moet worden gezet op een readonly attribuut dat de reeds gebruikte file grootte bevat.",
      EN: "Used in conjunction with an upload attribute, this hint is set on a read only attribute containing the file size currently used.",
    },
    link: "",
    component: ["attribute/number"],
  },
  MAX_TOTAL_FILESIZE: {
    hint: "max-total-file-size",
    description: {
      NL: "Wordt gebruikt in samenwerking met een upload attribuut, deze hint moet worden gezet op een readonly attribuut dat de maximaal toegestane file grootte bevat.",
      EN: "Used in conjunction with an upload attribute, this hint is set on a read only attribute containing the maximum allowed total file size.",
    },
    link: "",
    component: ["attribute/number"],
  },
  CREATE_ACTION: {
    hint: "create",
    description: {
      NL: "Markeer taak als creëer taak.",
      EN: "Mark task as create task",
    },
    component: ["form"],
  },
  UPDATE_ACTION: {
    hint: "update",
    description: {
      NL: "Markeer taak als bewerk taak.",
      EN: "Mark task as update task",
    },
    component: ["form"],
  },
  DELETE_ACTION: {
    hint: "delete",
    description: {
      NL: "Markeer taak als verwijder taak.",
      EN: "Mark task as delete task",
    },
    component: ["form"],
  },
  SORT_OPTIONS: {
    hint: "sort-options",
    description: {
      NL: "Sorteer opties alfabetisch",
      EN: "Sort options alphabetically",
    },
    component: ["attribute/choice"],
  },
  CASEVIEW_LINK: {
    hint: "case-view-link",
    description: {
      NL: "Markeer een case id reference attribute als de referentie naar de case view. Vervangt de self link van een lijst item",
      EN: "Mark a case id reference attribute as the reference to the case view. Replaces the self link of a list item",
    },
    component: ["attribute/reference", "list/datastore_table"],
  },
  DISABLED: {
    hint: "disabled",
    description: {
      NL: "Geeft aan of een attribuut uitgeschakeld is.",
      EN: "Indicates a disabled attribute.",
    },
    component: ["attribute"],
  },
  HIDE_IN_USER_INTERFACE: {
    hint: "hide-in-user-interface",
    description: {
      NL: "Verberg een tab in de user interface.",
      EN: "Hide a tab in the user interface.",
    },
    component: ["tab", "list", "groupingpanel"],
  },
  AVATAR: {
    hint: "avatar",
    description: {
      NL: "Geef het attribuut weer als de avatar van de gebruiker.",
      EN: "Render the attribute as the user's avatar.",
    },
    link: "",
    component: ["attribute/upload", "list/user_table"],
  },
  AVATAR_IN_TITLE: {
    hint: "avatar-in-title",
    description: {
      NL: "Geeft aan dat de avatarafbeelding in de titel wordt opgenomen. De avatarafbeelding wordt vóór het titel attribuut weergegeven in de lijstweergave en de snelle lijst quick view.",
      EN: "Indicates that the avatar image will be included in the title. The avatar image is shown in front of the title attribute in the list view and list quick view.",
    },
    link: "",
    component: ["list/user_table"],
  },
};
